
export const collectionColor: string = "#69672c";
export const applicationColor: string = "#2b931e";

var percentColors = [
  { pct: 0.0, color: { r: 0xff, g: 0x00, b: 0 } },
  { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0 } },
  { pct: 1.0, color: { r: 0x00, g: 0xff, b: 0 } } ];

export const getColorForPercentage = (pct: number): string => {
  for (var i = 1; i < percentColors.length - 1; i++) {
      if (pct < percentColors[i].pct) {
          break;
      }
  }
  var lower = percentColors[i - 1];
  var upper = percentColors[i];
  var range = upper.pct - lower.pct;
  var rangePct = (pct - lower.pct) / range;
  var pctLower = 1 - rangePct;
  var pctUpper = rangePct;
  var color = {
      r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
      g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
      b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
  };

  return rgbToHex(color.r, color.g, color.b);
  //return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
};


// Just used as a shortcut for below, completely optional
const //red = 0,
      orange = 30,
      //yellow = 60,
      green = 120;
      //turquoise = 180,
      //blue = 240,
      //pink = 300;

export const shedColorPercent = (percent: number): string => {
  //return hexColorPercent(percent, turquoise, pink);
  return hslToHex(orange, percent/2, percent/1.25);
}

export const silkingColorPercent = (percent: number): string => {
  //return hexColorPercent(percent, orange, green);
  return hslToHex(green, 80, percent/1.5);
}

// Based off a percent calculate a color in the range specified in the
// function.
export const hexColorPercent = (percent: number, start: number, end: number): string => {
  var a = percent / 100,
      b = (end - start) * a,
  		c = b + start;

  // Return a CSS HSL string
  return hslToHex(c, 45, 50);
}

export const hslToHex = (h: number, s: number, l: number): string => {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = (n: number): string => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export const rgbToHex = (r: number, g: number, b: number): string => {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export const invertHex = (hex: string): string => {
  return (Number(`0x1${hex}`) ^ 0xFFFFFF).toString(16).substr(1).toUpperCase()
}

const padZero = (str: string, len: number): string => {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

// // to invert colors
export const invertColor = (hex: string, bw: boolean): string => {
  if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
      // console.log('Invalid HEX color.');
      return '#000000';
  }
  var r: number = parseInt(hex.slice(0, 2), 16),
      g: number = parseInt(hex.slice(2, 4), 16),
      b: number = parseInt(hex.slice(4, 6), 16);
  if (bw) {
      // http://stackoverflow.com/a/3943023/112731
      return (r * 0.299 + g * 0.587 + b * 0.114) > 186
          ? '#000000'
          : '#FFFFFF';
  }
  // // invert color components
  // r = (255 - r).toString(16);
  // g = (255 - g).toString(16);
  // b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero((255 - r).toString(16), 2)
             + padZero((255 - g).toString(16), 2)
             + padZero((255 - b).toString(16), 2);
}
